export default {
    SEARCH: {
        title: 'דוחות חיפושים במערכת',
        displayFields: {
            keywords: 'מילות מפתח',
            results: 'תוצאות חיפוש',
            user_ip: 'כתובת IP',
            user_id: 'מזהה לקוח',
            subscription: 'סוג מנוי',
            date: 'תאריך'
        },
        fieldType: 'type'
    },
    ERROR: {
        title: 'דוחות על שגיאות במערכת',
        displayFields: {
            description: 'תיאור השגיאה',
            user_id: 'מזהה משתמש',
            company_id: 'company_id',
            user_ip: 'כתובת IP',
            date: 'תאריך',
            creator: 'creator'
        },
        fieldType: 'type'
    },
    CRAWLER: {
        title: 'CRAWLER',
        displayFields: {
            user_id: 'user_id',
            company_id: 'company_id',
            date: 'date',
            creator: 'creator'
        },
        fieldType: 'type'
    },
    BALANCER: {
        title: 'BALANCER',
        displayFields: {
            user_id: 'user_id',
            company_id: 'company_id',
            date: 'date'
        },
        fieldType: 'type'
    },
    MINER: {
        title: 'MINER',
        displayFields: {
            user_id: 'user_id',
            company_id: 'company_id',
            index: 'index',
            ids: 'ids',
            date: 'date'
        },
        fieldType: 'type'
    },
    DOCTORS_FULLTEXT: {
        keywords: 'attributes.keywords',
        title: 'רופאים לפי התמחות',
        fieldType: 'subType'
    },
    DOCTORS_LIST: {
        keywords: 'attributes.name',
        title: 'רופאים לפי שם',
        fieldType: 'subType'
    },
    CLINICS_LIST: {
        keywords: 'attributes.name',
        title: 'מרפאות לפי שם',
        fieldType: 'subType'
    },
    CLINICS_FULLTEXT: {
        keywords: 'attributes.keywords',
        title: 'מרפאות לפי התמחות',
        fieldType: 'subType'
    },
    DRUGS_LIST: {
        keywords: 'attributes.name',
        title: 'תרופות',
        fieldType: 'subType'
    },
    COLLECTIONS_FULLTEXT: {
        keywords: 'attributes.keywords',
        title: 'זכויות',
        fieldType: 'subType'
    },
    CRAWLER_INIT_SEND_CODE: {
        keywords: 'attributes.',
        title: 'CRAWLER_INIT_SEND_CODE',
        fieldType: 'subType'
    },
    CRAWLER_AUTH_USER: {
        keywords: 'attributes.',
        title: 'CRAWLER_AUTH_USER',
        fieldType: 'subType'
    },
    BALANCER_STATE: {
        keywords: 'attributes.',
        title: 'BALANCER_STATE',
        fieldType: 'subType'
    },
    MINE_INFO: {
        keywords: 'attributes.',
        title: 'MINE_INFO',
        fieldType: 'subType'
    }
}
